import React from "react";

import ProtectedRoute from "../../components/ProtectedRoute";
import PageHeader from "../../components/PageHeader";
import OrdersTable from "./OrdersTable";

import styles from "./Orders.module.css";

function Orders() {
  return (
    <div className={styles.container}>
      <PageHeader title="Orders" subtitle="All component orders" />

      <ProtectedRoute requiredAnyRole={["admin", "manager", "technician", "viewer"]}>
        <div className={styles.ordersSection}>
          <div className={styles.sectionHeader}>
            <h2 className={styles.sectionTitle}>All Orders</h2>
          </div>
          <div className={styles.tableContainer}>
            <OrdersTable />
          </div>
        </div>
      </ProtectedRoute>
    </div>
  );
}

export default Orders;
